import { render, staticRenderFns } from "./ConsultarProgramacoes.vue?vue&type=template&id=0c3d4a98&scoped=true"
import script from "./ConsultarProgramacoes.vue?vue&type=script&lang=ts"
export * from "./ConsultarProgramacoes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3d4a98",
  null
  
)

export default component.exports